import React from 'react'
import { MENU } from '@/config/menu.config'
import { cn } from '@/lib/utils'

interface SectorsMenuProps {
  onMouseEnter: () => void
  onMouseLeave: () => void
}

export function SectorsMenu({ onMouseEnter, onMouseLeave }: SectorsMenuProps) {
  const sectorsItem = MENU.find(item => item.label === 'Sectors')
  
  if (!sectorsItem?.children) return null

  const sectors = sectorsItem.children.filter(child => 'icon' in child)

  return (
    <div
      className="fixed inset-x-0 top-20 z-50 flex justify-center animate-in fade-in slide-in-from-top-2 duration-200"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="w-[600px] max-w-[90vw]">
      <div 
        className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl"
      >
        <div className="p-6">
          <h3 className="text-sm font-semibold text-primary uppercase tracking-wide mb-6 text-center">
            Industries We Serve
          </h3>
          
          <div className="grid grid-cols-2 gap-3">
            {sectors.map((sector) => (
              <a
                key={sector.label}
                href={sector.href}
                className={cn(
                  "flex items-center space-x-3 p-3 rounded-lg transition-all duration-200",
                  "hover:bg-muted/50 hover:shadow-md hover:scale-[1.02] group relative overflow-hidden"
                )}
              >
                {/* Glow effect on hover */}
                <div
                  className="absolute inset-0 bg-gradient-to-r from-primary/10 to-blue-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                />
                
                <div className="relative z-10 flex items-center space-x-3 w-full">
                  {sector.icon && (
                    <sector.icon className="w-5 h-5 text-muted-foreground group-hover:text-primary transition-colors flex-shrink-0" />
                  )}
                  <span className="text-sm font-medium group-hover:text-primary transition-colors">
                    {sector.label}
                  </span>
                </div>
              </a>
            ))}
          </div>
          
          {/* Bottom section */}
          <div 
            className="mt-6 pt-4 border-t border-border text-center"
          >
            <p className="text-xs text-muted-foreground">
              Serving organizations across Qatar and the region with tailored AI solutions
            </p>
          </div>
        </div>
      </div>
      </div>
    </div>
  )
}
